import { useAccountDetailTab, useCloseAccountDetail, useOpenAccountDetail, useSetAccountDetailTab } from "../../logic/stores/accountsStore.js";
import { AccountDetailHeader } from "./AccountDetailHeader.jsx";
import { AccountDetailTabs } from "./AccountDetailTabs.jsx";
import { AccountInfoTab } from "./AccountInfoTab.jsx";
import { AccountDevicesTab } from "./AccountDevicesTab.jsx";
import { AccountPermissionsTab } from "./AccountPermissionsTab.jsx";
import { AccountFmsTab } from "./AccountFmsTab.jsx";
import { AccountAssetTypesTab } from "./AccountAssetTypesTab.jsx";
import { AccountAssetsTab } from "./AccountAssetsTab.jsx";
import { AccountServiceAccountsTab } from "./AccountServiceAccountsTab.jsx";
import { AccountTabPlaceholder } from "./AccountTabPlaceholder.jsx";

const TAB_COPY = {
  icp: { title: "No ICP data yet", description: "Ideal customer profile details for this account will appear here." },
};

const FULL_HEIGHT_TABS = new Set(["devices", "fms", "assets"]);

export function AccountDetailPage({ account, accounts, onEdit, onDelete }) {
  const tab = useAccountDetailTab();
  const setTab = useSetAccountDetailTab();
  const closeDetail = useCloseAccountDetail();
  const openAccountDetail = useOpenAccountDetail();

  const handleSelectAccount = (id) => {
    if (id !== account.id) openAccountDetail(id, tab);
  };

  return (
    <div style={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0, overflow: "hidden" }}>
      <AccountDetailHeader
        account={account}
        accounts={accounts}
        onBack={closeDetail}
        onSelectAccount={handleSelectAccount}
      />
      <AccountDetailTabs activeTab={tab} onChange={setTab} />
      <div
        style={{
          flex: 1,
          overflow: FULL_HEIGHT_TABS.has(tab) ? "hidden" : "auto",
          padding: FULL_HEIGHT_TABS.has(tab) ? 0 : "14px 18px 18px",
          display: "flex",
          flexDirection: "column",
          minHeight: 0,
        }}
      >
        {tab === "info" && <AccountInfoTab account={account} onEdit={onEdit} onDelete={onDelete} />}
        {tab === "devices" && <AccountDevicesTab account={account} />}
        {tab === "permissions" && <AccountPermissionsTab account={account} />}
        {tab === "fms" && <AccountFmsTab account={account} />}
        {tab === "asset-types" && <AccountAssetTypesTab account={account} />}
        {tab === "assets" && <AccountAssetsTab account={account} />}
        {tab === "service-account" && <AccountServiceAccountsTab account={account} />}
        {tab !== "info" && tab !== "devices" && tab !== "permissions" && tab !== "fms" && tab !== "asset-types" && tab !== "assets" && tab !== "service-account" && <AccountTabPlaceholder {...TAB_COPY[tab]} />}
      </div>
    </div>
  );
}
